import DgTree from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTree.install = function (Vue) {
  Vue.component(DgTree.name, DgTree)
}
export default DgTree

export { DgTree }